import { Box, IconButton, Paper, Typography } from "@/common/styles/style";
import SearchBox from "@/molecules/searchBox";
import { styles } from "./style";
import { GroupsType } from "@/common/type/type";
import { MoreVert } from "@mui/icons-material";
import { getRoleName, roleInfo } from "@/helpers/getUserInfo";

interface GroupsProps {
  handleSearch: (searchType: string, value: string) => void;
  handlePopoverOpen: (
    event: React.MouseEvent<HTMLElement>,
    popoverContent: string | null
  ) => void;
  setSelectedGroup: (value: React.SetStateAction<GroupsType | null>) => void;
  setIsUnassigned: (value: React.SetStateAction<boolean>) => void;
  handleMenuClick: (event: React.MouseEvent<HTMLElement>, name: string) => void;
  setClickId: (value: React.SetStateAction<number>) => void;
  filteredGroups: GroupsType[];
  search: {
    tenant: string;
    group: string;
    user: string;
  };
  userRole: number;
  selectedGroup: GroupsType | null;
}

export default function Groups({
  handleSearch,
  handlePopoverOpen,
  setSelectedGroup,
  setIsUnassigned,
  handleMenuClick,
  setClickId,
  filteredGroups,
  search,
  userRole,
  selectedGroup,
}: GroupsProps) {
  return (
    <Paper sx={styles.paper}>
      <Box sx={styles.paperSearchWrapper}>
        <SearchBox
          searchType="addPlusBtn"
          onSearch={(value) => handleSearch("group", value)}
          handleAddButton={(e) =>
            handlePopoverOpen(e as React.MouseEvent<HTMLElement>, "group")
          }
        />
      </Box>
      <Box mt={2} sx={styles.paperTitle}>
        <Typography variant="h6">グループ一覧</Typography>
      </Box>
      <Box mt={2} sx={styles.paperList}>
        {(filteredGroups as GroupsType[] | [])
          .filter(
            (group) =>
              typeof group.name === "string" &&
              typeof search.group === "string" &&
              group.name.toLowerCase().includes(search.group.toLowerCase())
          )
          .map((group, index) => (
            <Box
              key={index}
              sx={{
                ...styles.listItem,
                ...(selectedGroup?.id === group.id ? styles.selectedItem : {}),
              }}
              onClick={() => {
                setIsUnassigned(false);
                setSelectedGroup(group);
                setClickId(group.id);
              }}
            >
              <Typography>{group.name}</Typography>
              {getRoleName(userRole) === roleInfo.admin ? (
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    handleMenuClick(e, group.name);
                  }}
                >
                  <MoreVert />
                </IconButton>
              ) : null}
            </Box>
          ))}
      </Box>
    </Paper>
  );
}
